import { render, staticRenderFns } from "./ImportWetec.vue?vue&type=template&id=a34c6176&scoped=true"
import script from "./ImportWetec.vue?vue&type=script&lang=ts"
export * from "./ImportWetec.vue?vue&type=script&lang=ts"
import style0 from "./ImportWetec.vue?vue&type=style&index=0&id=a34c6176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34c6176",
  null
  
)

export default component.exports